(function ($) {
    $(function () {
        var sliderWrapper = $(".js-hero-slider"),
            sliderAttributes = sliderWrapper.data('slider-settings'),
            iframes = sliderWrapper.find('.js-embed-player'),
            lazyImages = sliderWrapper.find('.js-slide-image'),
            lazyCounter = 0;

        // POST commands to YouTube or Vimeo API
        function postMessageToPlayer(player, command) {
            if (player == null || command == null) return;
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }

        // When the slide is changing
        function playPauseVideo(slick, control) {
            var currentSlide, slideType, startTime, player, video;
            currentSlide = slick.find(".slick-current");
            player = currentSlide.find("iframe").get(0);
            slideType = currentSlide.find("iframe").data("type");
            startTime = currentSlide.data("video-start");

            if (slideType === "vimeo") {
                switch (control) {
                    case "play":
                        if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
                            currentSlide.addClass('started');
                            postMessageToPlayer(player, {
                                "method": "setCurrentTime",
                                "value": '1'
                            });
                        }
                        postMessageToPlayer(player, {
                            "method": "play",
                            "value": 1
                        });
                        break;
                    case "pause":
                        postMessageToPlayer(player, {
                            "method": "pause",
                            "value": 1
                        });
                        break;
                }
            } else if (slideType === "youtube") {
                switch (control) {
                    case "play":
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "mute"
                        });
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "playVideo"
                        });
                        break;
                    case "pause":
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "pauseVideo"
                        });
                        break;
                }
            }
        }

        // Resize player
        function resizePlayer(iframes, ratio) {
            if (!iframes[0]) return;
            var win = $(".js-hero-slider"),
                width = win.width(),
                playerWidth,
                height = win.height(),
                playerHeight;
            ratio = ratio || 16 / 9;
            iframes.each(function () {
                var current = $(this);
                if (width / ratio < height) {
                    playerWidth = Math.ceil(height * ratio);
                    current.width(playerWidth).height(height).css({
                        left: (width - playerWidth) / 2,
                        top: 0
                    });
                } else {
                    playerHeight = Math.ceil(width / ratio);
                    current.width(width).height(playerHeight).css({
                        left: 0,
                        top: (height - playerHeight) / 2
                    });
                }
            });
        }

        // Function to update the title of the slick-track
        function updateSlickTrackTitle(slick) {
            var currentSlide = slick.find(".slick-current");
            var imgAltText = currentSlide.find('.slide-image img').attr('alt');
            sliderWrapper.find('.slick-track').attr('title', imgAltText || 'hero slider');
        }

       // DOM Ready
       $(function () {
        // Initialize
        sliderWrapper.on("init", function (event, slick) {
            slick = $(slick.$slider);
            updateSlideAttributes(sliderWrapper.find('.slick-slide .slide-media.slide-image'));
            setTimeout(function () {
                playPauseVideo(slick, "play");
            }, 1000);
            resizePlayer(iframes, 16 / 9);
            updateSlickTrackTitle(slick); // Set initial title
        });
        sliderWrapper.on("beforeChange", function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "pause");
        });
        sliderWrapper.on("afterChange", function (event, slick) {
            slick = $(slick.$slider);
            playPauseVideo(slick, "play");
            updateSlickTrackTitle(slick); // Update title on slide change
        });
        sliderWrapper.on("lazyLoaded", function (event, slick, image, imageSource) {
            lazyCounter++;
            if (lazyCounter === lazyImages.length) {
                lazyImages.addClass('show');
                // slideWrapper.slick("slickPlay");
            }
        });

        sliderWrapper.slick(sliderAttributes);

        // Add role for accessibility to the slick-track
        sliderWrapper.find('.slick-track').attr('role', 'listbox');
    });

        function updateSlideAttributes(selector) {
            selector.each(function () {
                var $slide = $(this).parents('.slick-slide');
                if ($slide.attr('aria-describedby') !== undefined) { // ignore extra/cloned slides
                    var $this = $(this);
                    if ($this.hasClass('slide-image--mobile-image')) {
                        return;
                    }
                    $this.attr('id', $slide.attr('aria-describedby'));
                }
            });
        }

        // Resize event
        $(window).on("resize.slickVideoPlayer", function () {
            resizePlayer(iframes, 16 / 9);
        });
    });
})(jQuery);
